export const getBooleanFilterValue = (value?: string): boolean | undefined => {
  return value ? !value?.toLowerCase()?.includes('no') : undefined;
};
